export const notfoundPaths = {
  login: 'login',
  home: 'app/home',
  dashboard: 'main/dashboard',
  charts: 'main/charts',
  map: 'main/map',
  objects: 'app/db/object',
  sensors: 'main/objects/sensor',
  configs: 'app/db/typicalconfig',
  device: 'app/db/device',
  controlprocedure: 'app/db/controlprocedure',
  zone: 'app/db/zone',
  paramcategories: 'app/db/paramcategory',
  controllermodel: 'app/db/controllermodel',
  paramtag: 'app/db/paramtag',
  deviceparamstateicon: 'app/db/deviceparamstateicon', /*SEM-487*/
  iconset: 'app/db/iconset', /*SEM-487*/
  import: 'main/config/import',
  export: 'main/config/export',
  commandlog: 'main/logs/command-log',
  setvaluelog: 'main/logs/setvalue-log',
  eventlog: 'main/logs/event-log',
  adminlog: 'main/logs/admin-log',
  notifylog: 'main/logs/notify-log',
  scheduletemplate: 'app/db/scheduletemplate',
  calendartemplate: 'app/db/calendar',
  iconlibrary: 'app/db/iconsets',
  imagesets: 'app/db/imgsets',
  events: 'app/db/event',
  lockedreason: 'app/db/lockedreason',
  extsystem: 'app/db/extsystem',
  typicalproblem: 'app/db/typicalproblem',
  commands: 'app/db/command',
  collector: 'app/db/collectorserver',
  notification: 'app/db/notificationserver',
  oauth2: 'app/oauth2provider',
  users: 'app/db/user',
  groups: 'app/db/usergroup',
  roles: 'app/db/sdirrole',
  profile: 'main/user/profile',
  usersubscription: 'app/user/usersubscription',
  contact: 'app/user/profileusernotify'
};
